import React from 'react';

// import Swiper core and required modules
import { Navigation, Autoplay } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import img5 from '../../../../../../../AssetsforIndividualProject/Frescoimages/frescoslider1.jpg';
import img1 from '../../../../../../../AssetsforIndividualProject/Frescoimages/frescoslider2.jpg';
import img2 from '../../../../../../../AssetsforIndividualProject/Frescoimages/frescoslider3.jpg';
import img3 from '../../../../../../../AssetsforIndividualProject/Frescoimages/frescoslider4.jpg';
import img4 from '../../../../../../../AssetsforIndividualProject/Frescoimages/frescoslider5.jpg';

const FrescoSlider = () => {
    return (
        <div className='container my-5'>
              <Swiper
                modules={[Navigation, Autoplay]}
                autoplay={true}
                breakpoints={{
                    0:{
                    spaceBetween:10,      
                    slidesPerView: 1,
                    },
                    480: {
                    spaceBetween:10,
                    slidesPerView: 2,
                    },
                    768: {
                    spaceBetween:15,
                    slidesPerView: 2,
                    },
                    1024: {
                    spaceBetween:30,
                    slidesPerView:4,
                    },
                }}
                >
                <SwiperSlide>
                    <img className='w-100' src={img1} alt='atharva slideone'/>
                </SwiperSlide>
                <SwiperSlide>
                    <img className='w-100' src={img2} alt='atharva slideone'/>
                </SwiperSlide>
                <SwiperSlide>
                    <img className='w-100' src={img3} alt='atharva slideone'/>
                </SwiperSlide>
                <SwiperSlide>
                    <img className='w-100' src={img4} alt='atharva slideone'/>
                </SwiperSlide>
                <SwiperSlide>
                    <img className='w-100' src={img5} alt='atharva slideone'/>
                </SwiperSlide>

                </Swiper>
        </div>
    );
};

export default FrescoSlider;